import { Action } from "@ngrx/store";

export const INCREMENTAR = '[NumeroEnProcceso] Incrementar';

export const RESET = '[NumeroEnProceso] Reset';

export class IncrementarAction implements Action {
  readonly type = INCREMENTAR;
  constructor ( public payload: number) {}
}

export class ResetAction implements Action {
  readonly type = RESET;

  constructor ( public payload: number) {}
}

export type actions = IncrementarAction
                      | ResetAction;



// WEBPACK FOOTER //
// ./src/store/actions/domiciliosapp.actions.ts